import { Box, Stack, IconButton, Tooltip } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Logo from '../../../components/logo'
import { NavSectionMini } from '../../../components/nav-section'
import { NAV } from '../../../config-global'
import { hideScrollbarX } from '../../../utils/cssStyles'
import NavToggleButton from './NavToggleButton'
import { useNavVerticalContext } from './NavVerticalContext'
import { useNavData } from './config-navigation'
import { useAuthContext } from '../../../auth/useAuthContext'
import { PATH_AUTH } from '../../../routes/paths'
import Iconify from '../../../components/iconify'

export default function NavMini() {
  const navigate = useNavigate()
  const { logout } = useAuthContext()
  const { navData } = useNavVerticalContext()
  const defaultNavData = useNavData()

  const handleLogout = () => {
    logout()
    navigate(PATH_AUTH.login, { replace: true })
  }

  const navConfig = navData || defaultNavData
  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 55,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScrollbarX,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2, maxWidth: 64 }} />

        <NavSectionMini data={navConfig} />

        <Box sx={{ flexGrow: 1 }} />

        <Stack spacing={1} alignItems="center" sx={{ pb: 2 }}>
          <Tooltip title="Sair" placement="right">
            <IconButton onClick={handleLogout} color="error">
              <Iconify icon="mingcute:power-fill" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
    </Box>
  )
}
